import React, { useId, useState } from 'react';

import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Sheet from '@amzn/meridian/sheet';
import Text from '@amzn/meridian/text';

import { INTRO_PARAGRAPHS, METRIC_DEFINITIONS } from './constants';

/** Info button that opens a sheet with each metric's definition. */
const PlacementMetricDefinitions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const titleId = useId();
  const close = () => setIsOpen(false);

  return (
    <>
      <Button type="link" size="small" onClick={() => setIsOpen(true)}>
        <Icon tokens={infoKnockoutTokens}>Metric definitions</Icon>
      </Button>
      <Sheet type="overlay" side="end" open={isOpen} onClose={close} aria-labelledby={titleId}>
        <Column spacing="400" width={420}>
          <Row widths={['fill', 'fit']}>
            <Heading level={2} type="h300" id={titleId}>
              Active Placement Metric Definitions
            </Heading>
            <Button onClick={close} type="icon">
              <Icon tokens={closeTokens}>Close sheet</Icon>
            </Button>
          </Row>
          <Column spacing="400">
            {INTRO_PARAGRAPHS.map((paragraph) => (
              <Text key={`intro-${paragraph}`} type="b200">
                {paragraph}
              </Text>
            ))}
            {/* Divider goes above each term so the intro gets one and the last term doesn't */}
            {METRIC_DEFINITIONS.map(({ term, definition }) => (
              <React.Fragment key={`term-${term}`}>
                <Divider />
                <Column spacing="100">
                  <Heading level={3} type="h100">
                    {term}
                  </Heading>
                  <Text type="b200">{definition}</Text>
                </Column>
              </React.Fragment>
            ))}
          </Column>
        </Column>
      </Sheet>
    </>
  );
};

export default PlacementMetricDefinitions;
